import { render, staticRenderFns } from "./VentaOnlineComponent.vue?vue&type=template&id=343f3c9a"
import script from "./VentaOnlineComponent.vue?vue&type=script&lang=js"
export * from "./VentaOnlineComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports